module.exports = __webpack_public_path__ + "img/promotion-B.71e73549.svg";